import * as React from "react"
import { XBlock, XMasonry } from "react-xmasonry"

interface State {
    columnWidth: number
}

interface OwnProps {
    numberOfColumns: number
}

type Props = OwnProps & React.HTMLAttributes<HTMLDivElement>

export default class GridMasonry extends React.Component<Props, State> {
    container: React.RefObject<HTMLDivElement>

    static defaultProps: Partial<Props> = {
        numberOfColumns: 4,
    }

    constructor(props: Props) {
        super(props)
        this.container = React.createRef()
        this.state = {
            columnWidth: -1,
        }
    }

    componentDidMount(): void {
        window.addEventListener("resize", this.calculateColumnWidth)
        this.calculateColumnWidth()
    }

    componentWillUnmount(): void {
        window.removeEventListener("resize", this.calculateColumnWidth)
    }

    render(): JSX.Element {
        const { children, numberOfColumns, ...attrs } = this.props
        const { columnWidth } = this.state

        return (
            <div ref={this.container} {...attrs}>
                {columnWidth > 0 && (
                    <XMasonry
                        maxColumns={numberOfColumns}
                        targetBlockWidth={columnWidth}
                        center={false}
                        smartUpdate={true}
                        smartUpdateCeil={500}
                    >
                        {React.Children.map(
                            children,
                            (child: React.ReactElement) => {
                                const width = child?.props?.width ?? 1
                                return <XBlock width={width}>{child}</XBlock>
                            },
                        )}
                    </XMasonry>
                )}
            </div>
        )
    }

    calculateColumnWidth = (): void => {
        if (!!this.container?.current) {
            this.setState({
                columnWidth:
                    this.container.current.offsetWidth /
                    this.props.numberOfColumns,
            })
        }
    }
}
